import React from "react";
import styled from "styled-components";
//Router
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
const Nav = () => {
  const { pathname } = useLocation();
  return (
    <StyledNav>
      <h1>
        <Link id="logo" to="/">
          Capture
        </Link>
      </h1>
      <ul>
        <li>
          <Link to="/">1. About</Link>
          <Line
            transition={{ duration: 0.5 }}
            animate={{ width: pathname === "/" ? "50%" : "0%" }}
            initial={{ width: 0 }}
          />
        </li>
        <li>
          <Link to="/work">2. Our Work</Link>
          <Line
            transition={{ duration: 0.5 }}
            animate={{ width: pathname === "/work" ? "50%" : "0%" }}
            initial={{ width: 0 }}
          />
        </li>
        <li>
          <Link to="/contact">3. Contact Us</Link>
          <Line
            transition={{ duration: 0.5 }}
            animate={{ width: pathname === "/contact" ? "50%" : "0%" }}
            initial={{ width: 0 }}
          />
        </li>
      </ul>
    </StyledNav>
  );
};

const StyledNav = styled.nav`
  min-height: 10vh;
  display: flex;
  margin: auto;
  justify-content: space-between;
  background-color: #282828;
  align-items: center;
  padding: 1rem 10rem;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 5;
  a {
    color: white;
    text-decoration: none;
  }
  ul {
    display: flex;
    list-style: none;
    li {
      padding-left: 10rem;
      position: relative;
    }
  }
  #logo {
    font-family: "Lobster", cursive;
    font-size: 1.8rem;
    font-weight: lighter;
  }
  @media (max-width: 1300px) {
    flex-direction: column;
    padding: 1rem;
    #logo {
      display: inline-block;
      margin: 1rem;
    }
    ul {
      padding: 2rem;
      justify-content: space-around;
      width: 100%;
      li {
        padding: 0;
        a {
          font-size: 1.3rem;
        }
      }
    }
  }
`;
const Line = styled(motion.div)`
  height: 0.3rem;
  background: #23d997;
  width: 0%;
  position: absolute;
  bottom: -80%;
  left: 60%;
  @media (max-width: 1300px) {
    left: 0;
  }
`;
export default Nav;
